import { request } from '../client';

// The payload is built by utils/orderPlacement.buildOrderPayload from the
// checkout quote (couponCode, quoteToken, expectedGrandTotal) — nothing is
// computed here. The Idempotency-Key names one intended order attempt.
export const placeOrder = (payload, idempotencyKey, options = {}) =>
  request('/orders', { ...options, method: 'POST', body: payload, idempotencyKey });

// Continue an order the backend queued (PENDING_ALLOCATION) once a store has
// been assigned: finalizes Cash on Delivery, or returns the payment order.
export const resumeCheckout = (saleId, options = {}) => request(`/orders/${saleId}/resume-checkout`, { ...options, method: 'POST' });

export const confirmPayment = (saleId, razorpayPaymentId, razorpaySignature, options = {}) =>
  request(`/orders/${saleId}/confirm-payment`, {
    ...options,
    method: 'POST',
    body: { razorpayPaymentId, razorpaySignature },
  });

export const getPaymentStatus = (saleId, options = {}) => request(`/orders/${saleId}/payment-status`, options);

// What a placement attempt (its Idempotency-Key) became — read only: the Sale
// it made (if any), its idempotency claim (if still live) and the replay window.
// madeAt / clientNow (this browser's clock) let the backend check, on its own
// clock, whether "no order with this key" can be trusted.
export const getPlacementAttempt = (key, { madeAt, clientNow, ...options } = {}) => request(`/orders/attempts/${encodeURIComponent(key)}`, {
  ...options,
  params: Number.isFinite(madeAt) && Number.isFinite(clientNow) ? { madeAt, clientNow } : undefined,
});

export const listOrders = (params) => request('/orders', { params });

export const getOrder = (id, options = {}) => request(`/orders/${id}`, options);

export const getOrderTracking = (id) => request(`/orders/${id}/tracking`);

export const getDeliveryCode = (id) => request(`/orders/${id}/delivery-code`);

export const getCheckoutGroup = (groupId, options = {}) => request(`/checkout-groups/${groupId}`, options);

export const resumeCheckoutGroup = (groupId, options = {}) => request(`/checkout-groups/${groupId}/resume-checkout`, { ...options, method: 'POST' });

export const confirmCheckoutGroupPayment = (groupId, razorpayPaymentId, razorpaySignature, options = {}) =>
  request(`/checkout-groups/${groupId}/confirm-payment`, {
    ...options,
    method: 'POST',
    body: { razorpayPaymentId, razorpaySignature },
  });

export const getCheckoutGroupPaymentStatus = (groupId, options = {}) => request(`/checkout-groups/${groupId}/payment-status`, options);
